import { Component, OnInit, OnDestroy, Input, OnChanges, SimpleChange, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup }                 from '@angular/forms';
import { NgForm } from '@angular/forms';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { NormasService } from '../_services/normas.service';
import { EvidenciasService } from '../_services/evidencias.service';
import { Modulo } from '../_models/modulo.model';
import { Supuesto } from '../_models/supuesto.model';
declare var jQuery:any;

import { GlobalEventsManager } from "../_services/globaleventsmanager.service";


@Component({
  selector: 'formulariomodulopenal',
  templateUrl: 'formulariomodulopenal.template.html',
  //providers:  [PreguntasService]
})
export class FormularioModuloPenalComponent  implements OnInit, OnDestroy, OnChanges {

  @Input() idareadelito: any;
  @Input() idriesgo: any;
  @Input() idsupuesto: any;

  @Output() onChangeModulo = new EventEmitter<any>();

  subscription: Subscription;
  id_riesgo: number;
  id_areadelito: number;
  id_supuesto: number;

  listabloques: any[];
  listaareas: any[];

  supuesto: Supuesto;

  emisorcambio: any = {
    anadir: false,
    change: false
  }

  listatiposancion: any = [];


  constructor(private seguridad: SeguridadService,
              private router:Router,
              private normasService: NormasService,
              private evidenciasService: EvidenciasService,
              private globalEventsManager: GlobalEventsManager,
              private activatedRoute: ActivatedRoute){

  }

  ngOnInit(){

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });



    this.getListaAreasDelito();

    this.getLista("ListagetTipoSancion");

  }

  getLista(accion: string){
    this.evidenciasService.getLista(accion).subscribe(
      data => {
        if (data){

          let json = data.json();

          if (accion == "ListagetTipoSancion"){
            this.listatiposancion = json.lista;
          }
        }
      }
    );
  }

  ngOnChanges(changes: {[ propName: string]: SimpleChange}){
    if (changes['idriesgo']){
      this.id_riesgo = changes['idriesgo'].currentValue;
    }
    if (changes['idareadelito']){
      this.id_areadelito = changes['idareadelito'].currentValue;
    }
    if (changes['idsupuesto']){
      this.id_supuesto = changes['idsupuesto'].currentValue;
    }
    this.getSupuesto(this.id_supuesto);
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  onSubmit(formulario: NgForm, event: Event){
    event.preventDefault;
    //console.log(formulario);
    let supuesto: any;

    console.log(this.supuesto);

    supuesto = {
      abr: this.supuesto.abr,
      descripcion: this.supuesto.descripcion,
      id_comportamiento: this.supuesto.id_supuesto,
      id_areadelito: this.supuesto.id_areadelito,
      id_riesgo: this.supuesto.id_riesgo,
      articulado: this.supuesto.articulado,
      referencia: this.supuesto.referencia,
      jurisprudencia_titulo : this.supuesto.jurisprudencia_titulo,
      jurisprudencia_texto : this.supuesto.jurisprudencia_texto,
      jurisprudencia_enlace : this.supuesto.jurisprudencia_enlace,
      sancion_infraccion : this.supuesto.sancion_infraccion,
      sancion_id_tipo : this.supuesto.sancion_id_tipo,
      sancion_riesgo_max : this.supuesto.sancion_riesgo_max,
      sancion_riesgo_min : this.supuesto.sancion_riesgo_min,
      sancion_disciplinaria : this.supuesto.sancion_disciplinaria,
      sancion_otrasconsecuencias : this.supuesto.sancion_otrasconsecuencias,
      normativa: this.supuesto.normativa
    };

    //console.log(JSON.stringify(norma));

    this.normasService.setSupuesto(supuesto).subscribe(
      data => {
        //console.log (data.json());
        if (data){

          let al: any = {
            "texto" : "Supuesto guardado",
            "mostrar": true
          };
          this.globalEventsManager.setAlert(al);

          this.updateModulo(data);
        }
      }
    );
  }

  guardarAnadir(formulario: NgForm, event: Event){
    this.emisorcambio.anadir = true;
    this.onSubmit(formulario,event);
  }

  guardar(formulario: NgForm, event: Event){
    this.emisorcambio.anadir = false;
    this.onSubmit(formulario,event);
  }

  getSupuesto(id_supuesto){

    this.supuesto = new Supuesto();

    this.normasService.getSupuesto(id_supuesto).subscribe(
      data => {

        if (data){

          console.log(data.json());

          if (id_supuesto != 0){

            this.supuesto.abr = data.json().comportamiento.abr;
            this.supuesto.descripcion = data.json().comportamiento.descripcion;
            this.supuesto.id_areadelito = data.json().comportamiento.id_areadelito;
            this.supuesto.id_riesgo = data.json().comportamiento.id_riesgo;
            this.supuesto.id_supuesto = data.json().comportamiento.id_comportamiento;
            this.supuesto.articulado = data.json().comportamiento.articulado;
            this.supuesto.referencia = data.json().comportamiento.referencia;

            this.supuesto.jurisprudencia_titulo = data.json().comportamiento.jurisprudencia_titulo;
            this.supuesto.jurisprudencia_texto = data.json().comportamiento.jurisprudencia_texto;
            this.supuesto.jurisprudencia_enlace = data.json().comportamiento.jurisprudencia_enlace;
            this.supuesto.sancion_infraccion = data.json().comportamiento.sancion_infraccion;
            this.supuesto.sancion_id_tipo = data.json().comportamiento.sancion_id_tipo;
            this.supuesto.sancion_riesgo_max = data.json().comportamiento.sancion_riesgo_max;
            this.supuesto.sancion_riesgo_min = data.json().comportamiento.sancion_riesgo_min;
            this.supuesto.sancion_disciplinaria = data.json().comportamiento.sancion_disciplinaria;
            this.supuesto.sancion_otrasconsecuencias = data.json().comportamiento.sancion_otrasconsecuencias;

            this.supuesto.normativa = data.json().comportamiento.normativa;

            /*if (this.supuesto.normativa){
              for (let i=0; i < this.supuesto.normativa.length; i++){
                this.supuesto.normativa[i].visible = true;
              }
            }*/

          }else{
            this.supuesto.id_riesgo = this.id_riesgo;
            this.supuesto.id_areadelito = this.id_areadelito;
          }

          this.getListaRiesgos(this.supuesto.id_areadelito);
        }

      }
    );
  }

  updateModulo(data){

    this.supuesto = new Supuesto();

    this.supuesto.abr = data.json().comportamiento.abr;
    this.supuesto.descripcion = data.json().comportamiento.descripcion;
    this.supuesto.id_areadelito = data.json().comportamiento.id_areadelito;
    this.supuesto.id_riesgo = data.json().comportamiento.id_riesgo;
    this.supuesto.id_supuesto = data.json().comportamiento.id_comportamiento;
    this.supuesto.articulado = data.json().comportamiento.articulado;
    this.supuesto.referencia = data.json().comportamiento.referencia;

    this.supuesto.jurisprudencia_titulo = data.json().comportamiento.jurisprudencia_titulo;
    this.supuesto.jurisprudencia_texto = data.json().comportamiento.jurisprudencia_texto;
    this.supuesto.jurisprudencia_enlace = data.json().comportamiento.jurisprudencia_enlace;
    this.supuesto.sancion_infraccion = data.json().comportamiento.sancion_infraccion;
    this.supuesto.sancion_id_tipo = data.json().comportamiento.sancion_id_tipo;
    this.supuesto.sancion_riesgo_max = data.json().comportamiento.sancion_riesgo_max;
    this.supuesto.sancion_riesgo_min = data.json().comportamiento.sancion_riesgo_min;
    this.supuesto.sancion_disciplinaria = data.json().comportamiento.sancion_disciplinaria;
    this.supuesto.sancion_otrasconsecuencias = data.json().comportamiento.sancion_otrasconsecuencias;

    this.supuesto.normativa = data.json().comportamiento.normativa;

    this.getListaRiesgos(this.supuesto.id_areadelito);

    this.actualizaPadre();
  }

  actualizaPadre(){
    //this.onChangeModulo.emit(true);
    this.onChangeModulo.emit(this.emisorcambio);
    if (this.emisorcambio.anadir){
      this.getSupuesto(0);
    }
  }

  cambioIdBloque(valor){
    console.log(valor);
    this.getListaRiesgos(valor);
  }

  getListaAreasDelito(){
    this.normasService.getListaAreasDelito().subscribe(
      data => {
        if (data){
          this.listabloques = data.json().lista;
        }
      }
    );
  }

  getListaRiesgos(id_areadelito: number){

    this.normasService.getListaRiesgos(id_areadelito).subscribe(
      data => {
        if (data){
          this.listaareas = data.json().lista;
        }

      }
    );
  }

  anadirNorma(){
    var nuevanorma: any = { descripcion: "", articulado: "", enlace: "", comentario_publico: "", comentario_interno: "" };
    this.supuesto.normativa.push(nuevanorma);
  }

  borrarNorma(i){
    this.supuesto.normativa.splice(i,1);
  }

}



// WEBPACK FOOTER //
// ./src/app/inventarionormaspenal/formulariomodulopenal.component.ts